document.addEventListener('DOMContentLoaded', function() {

  // Mobile menu toggle
  var menuToggle = document.querySelector('.site-header__menu-toggle');
  var mobileNav = document.querySelector('.site-header__nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function() {
      mobileNav.classList.toggle('is-open');
    });
  }

  // Size buttons
  document.querySelectorAll('.size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

});